module.exports = __webpack_public_path__ + "static/img/need-us.4ab00fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/need-us.png
// module id = 8Xr6
// module chunks = 0